import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-column-chooser',
    templateUrl: './column-chooser.component.html',
    styleUrls: ['./column-chooser.component.scss']
})
export class ColumnChooserComponent implements OnInit {

    @Input() id: string = '';
    @Input() displayedColumns: any[] = [];
    @Input() selectable: boolean = false;
    @Input() title: string = '';
    @Input() options: any[] = [];
    @Input() lastIndex: number;
    @Input() translationsPath: string = '';


    @Output() columnChange = new EventEmitter<{ action: string; value: any; }>();

    public selectedValue = null;
    private selectedOptions = [];

    constructor() { }

    ngOnInit(): void { }

    /**
     * Add selected column to grid columns
     * @param item
     * @param width
     */
    public addColumn(e: any, width = 100) {

        if (e !== null) {
            let newColumn = {
                key: e.name,
                title: this.translationsPath + `${this.id}.` + e.name,
                type: 'none', // type is not defined because custom columns are not filterable
                orderIndex: this.lastIndex + 1,
                width: width,
                hidden: false,
                group: this.id,
                isNew: true
            }

            setTimeout(() => {
                this.selectedValue = null;
                this.displayedColumns.push(newColumn);
                this.columnChange.emit({ action: 'add', value: newColumn });
            })
        }
    }


    /**
     * Remove selected column from grid columns
     * @param column
     */
    public removeColumn(col: any): void {
        this.displayedColumns = this.displayedColumns.filter(x => x.key !== col.key);

        let item = this.selectedOptions.find(o => o.name === col.key);
        this.selectedOptions = this.selectedOptions.filter(o => o.name !== col.key);

        this.options.push(item);
        this.options.sort((a, b) => a.searchValues.localeCompare(b.searchValues));

        this.columnChange.emit({ action: 'remove', value: col });
    }


    /**
     * Update column visibility
     * @param event checkbox event
     * @param item the column
     */
    public updateColumn(event: MatCheckboxChange, item: any) {

        let tmp = item;
        tmp.hidden = !event.checked;

        if (tmp.hidden) {
            tmp.orderIndex = 0; // reset hidden column index
        } else {
            tmp.orderIndex = this.lastIndex + 1;
        }

        this.columnChange.emit({ action: 'update', value: tmp });
    }



    /**
     * ngOnChanges to detect when an input property has change
     * @param changes
     */
    public ngOnChanges() {

        if (this.displayedColumns.length > 0) {

            if (this.options && this.options.length > 0) {
                // store selected options
                this.options.forEach(item => {
                    if (this.displayedColumns.some(col => col.key === item.name) ||
                        item.name === 'ResponsiblePerson' || item.name === 'Orderer' ||
                        item.name === 'Supplier') {

                        if (this.selectedOptions.indexOf(item) < 0) {
                            this.selectedOptions.push(item);
                        }
                    }
                });

                if (this.selectedOptions.length > 0) {
                    // remove selected options from dropdown list
                    this.selectedOptions.forEach(element => {
                        const index = this.options.findIndex(x => x.name === element.name);
                        if (index > -1) {
                            this.options.splice(index, 1);
                        }
                    });
                }

            }

        }
    }
}
